module.exports = __webpack_public_path__ + "static/media/imagem1.0520e2a6.jpeg";